import LeftImageArea from '../components/LeftImageArea';
import Support from '../components/Support';
import '../components/registration.css';

const AppointmentAdLayout = ({ children }) => {
  return <div>{children}</div>;
};

export default AppointmentAdLayout;
